// Dependencies
import React from 'react';
import ReactDOM from 'react-dom';

// Components
import App from './components/App';

// Utils
import { appRoot } from './utils/config';

// Stylesheets
require( process.env.NODE_ENV === 'development' 
  ? './assets/stylesheets/main-dev.scss'
  : './assets/stylesheets/main.scss'
)

ReactDOM.render( 
  <React.StrictMode>
    <App />
  </React.StrictMode>, 
  document.querySelector( appRoot )
);